import * as yup from 'yup';
import 'yup-phone';
import {
	noRuEmailDomainValidator,
	noCiryllicCharsEmailDomainValidator,
} from '../../validators/email.validators';

export const studentValidationSchema = yup.object({
	name: yup.string(),
	email: yup
		.string()
		.email()
		.required()
		.test(noRuEmailDomainValidator)
		.test(noCiryllicCharsEmailDomainValidator)
});

export const studentValidationSchemaWithNotes = yup.object({
	name: yup.string(),
	email: yup
		.string()
		.email()
		.required()
		.test(noRuEmailDomainValidator)
		.test(noCiryllicCharsEmailDomainValidator),
	notes: yup.string().required(),
});
